import IconSearch from '@mnd-frontend/icons/components/Search';
import { Input } from '@mnd-frontend/ui/publish/components';
import { MEDIA_SMALL } from '@mnd-frontend/ui/shared/tokens';
import { useCallback, useState } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  flex-grow: 2;
  width: 100%;
  @media (min-width: ${MEDIA_SMALL}px) {
    margin-top: auto;
  }
`;

interface Props {
  name: string;
  onChange: (name: string, value: string) => void;
  placeholder: string;
  defaultValue?: string;
}

const FilterSearch = ({ name, onChange, placeholder, defaultValue }: Props) => {
  const [searchValue, setSearchValue] = useState(defaultValue ?? '');
  const handleChange: React.ChangeEventHandler<HTMLInputElement> = useCallback(
    e => {
      setSearchValue(e.target.value);
      onChange(name, e.target.value);
    },
    [onChange, name],
  );
  return (
    <Wrapper>
      <Input
        id="filter-search"
        onChange={handleChange}
        label={placeholder}
        value={searchValue}
        trailingIcon={<IconSearch />}
      />
    </Wrapper>
  );
};

export default FilterSearch;
